import type { ProductWithNoMoreOptionValue } from 'apiConnector/discover/lifeCycle';
import { RenderPercent } from 'components/discover/post-trade/life-cycle/section/render-percent';
import { Section } from 'components/discover/post-trade/life-cycle/section/section-content';

import type { LifeCycleItemProps } from './section-container';
import { LifeCycleSectionContainer, lifeCycleApi } from './section-container';

export function WithNoMoreOptionValueItem(props: LifeCycleItemProps) {
  return (
    <LifeCycleSectionContainer
      title="withNoMoreOptionValue"
      fetchData={lifeCycleApi.fetchWithNoMoreOptionValue}
      {...props}
    >
      {({ gamma, vega }: ProductWithNoMoreOptionValue) => <LifecycleBadge gamma={gamma} vega={vega} />}
    </LifeCycleSectionContainer>
  );
}

type BadgeProps = Pick<ProductWithNoMoreOptionValue, 'gamma' | 'vega'>;

function LifecycleBadge({ gamma, vega }: BadgeProps) {
  return (
    <Section.Provider>
      <Section.Header />
      <Section.Overlay>
        <table className="table table-sm table-borderless mb-0 fs-6">
          <Section.TableHeader
            translationKeys={[
              'discover.lifeCycle.withNoMoreOptionValue.vega',
              'discover.lifeCycle.withNoMoreOptionValue.gamma',
            ]}
          />
          <tbody className="text-secondary">
            <tr>
              <Section.TableCell>
                <RenderPercent value={vega} e2e="life-cycle-with-no-more-option-value-vega" />
              </Section.TableCell>
              <Section.TableCell>
                <RenderPercent value={gamma} e2e="life-cycle-with-no-more-option-value-gamma" />
              </Section.TableCell>
            </tr>
          </tbody>
        </table>
      </Section.Overlay>
    </Section.Provider>
  );
}
